import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/shared/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { AuthService } from 'app/shared/services/auth.service';
import { Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService, NB_THEME_OPTIONS } from '@nebular/theme';




@Component({
  selector: 'app-user-permission',
  templateUrl: './user-permission.component.html',
  styleUrls: ['./user-permission.component.css']
})
export class UserPermissionComponent implements OnInit {

  userList: any;


  isSaveBtnDisabled: boolean = false;
  isDeleteBtnDisabled: boolean = false;
  showProcessingIndicator = false;
  isDark: boolean = false;

  selectedUser : string ;
  userPermissionArray =[];
  selectAll : boolean = false;


  constructor(private userService : UserService, 
              private toastr: ToastrService, 
              private dialogService: DialogService,
              private router : Router,
              private authService: AuthService,
              private themeService: NbThemeService,
            ) { }

  ngOnInit(): void {

    this.getUserList();
    this.initializeUserPermissions();


     this.themeService.onThemeChange()
     .subscribe(themeName =>{
          this.isDark  = themeName.name ==='dark' ? true : false;
         });

    }

   


 
    initializeUserPermissions(){
      this.userPermissionArray = [
        {moduleCode :'DB',moduleName : "Dashboard",module:0, read : null, create : null, approve : null, delete : null},
        {moduleCode :'COM',moduleName : "Company Profile",module:0, read : 0, create : 0, approve : null, delete : null},
        {moduleCode :'EM',moduleName : "Employee Master",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'SM',moduleName : "Supplier Master",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'CM',moduleName : "Customer Master",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'VH',moduleName : "Vehicle Register",module:0, read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'IM',moduleName : "Item Master",module:0, read : 0, create : 0, approve : null, delete : 0},

        // {moduleCode :'PO',moduleName : "Purchase Order",module:0, read : 0, create : 0, approve : null, delete : 0},
        // {moduleCode :'PI',moduleName : "Purchase Invoice",module:0, read : 0, create : 0, approve : null, delete : 0},
        // {moduleCode :'PR',moduleName : "Purchase Return",module:0, read : 0, create : 0, approve : null, delete : 0},
        // {moduleCode :'PMT',moduleName : "Payment",module:0, read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'QUO',moduleName : "Quotation",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'INV',moduleName : "Invoice",module:0, read : 0, create : 0, approve : null, delete : 0},
        // {moduleCode :'SR',moduleName : "Sale Return",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'RECEIPT',moduleName : "Receipt",module:0, read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'EXP',moduleName : "Expenses",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'MACC',moduleName : "Manage Account",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'CB_ENTRY',moduleName : "Cash & Bank Entry",module:0, read : 0, create : 0, approve : null, delete : 0},
        {moduleCode :'CHQ',moduleName : "Cheques",module:0,read : null, create : null, approve : null, delete : null},
        {moduleCode :'CB_BAL',moduleName : "Cash & Bank Balances",module:0,read : null, create : null, approve : null, delete : null},
        
        {moduleCode :'RPT_CB',moduleName : "Customer Outstanding Report",module:0,read : null, create : null, approve : null, delete : null},
        {moduleCode :'RPT_SALE',moduleName : "Sales Report",module:0, read : null, create : null, approve : null, delete : null},
        {moduleCode :'RPT_INV',moduleName : "Invoice Report",module:0, read : null, create : null, approve : null, delete : null},
        {moduleCode :'RPT_EXP',moduleName : "Expenses Report",module:0, read : null, create : null, approve : null, delete : null},
        {moduleCode :'RPT_PNL',moduleName : "Profit & Loss Statement",module:0, read : null, create : null, approve : null, delete : null},
       
        {moduleCode :'USER',moduleName : "User Management",module:0, read : null, create : null, approve : null, delete : null},
        {moduleCode :'SETTINGS',moduleName : "Settings",module:0, read : null, create : null, approve : null, delete : null},
        {moduleCode :'BACKUP',moduleName : "Backup",module:0, read : 0, create : 0, approve : null, delete : 0},

        {moduleCode :'FILE',moduleName : "File Upload",module:0, read : 0, create : 0, approve : null, delete : 0},
     
      ]
     
     }


     checkedAllPermissions(){
      this.userPermissionArray.forEach(key=>{
        key.module = 1;
        key.read = 1;
        key.create = 1;
        if(key.approve !=null){
          key.approve = 1;
        }
        if(key.delete !=null){
          key.delete = 1;
        }
      });
     }



  getUserList(){
    this.userService.getAll()
     .subscribe(
        (data) => {
                  this.userList = data.filter((el)=>{
                    return el.UserName!=='admin';                          
                  });
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  
       
     }





    mapValuesToModel(){
      this.userPermissionArray.forEach(key=>{
        key['username']=this.selectedUser;
        key['createdBy']=this.authService.getUserLoggedIn();
      })

      var data = this.userPermissionArray.map(val =>{
        return [val.username,val.moduleCode,val.moduleName,val.module,val.read,val.create,val.approve,val.delete,val.createdBy]
      })
      
      return data;
     }

    saveUserPermissionBtnClick(): void {

      var getData = this.mapValuesToModel();

      if(this.selectedUser){

          this.userService.create(getData)
          .subscribe(
            (res)=> {
              this.toastr.success('User permission granted', 'Success');    
              this.clearPanel();  
              this.showProcessingIndicator = false;
            },
            (err) => {
              this.toastr.error('Failed to grant user permission', 'Failure');
              this.showProcessingIndicator = false;
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            },
            )    
    
       }else{
        this.toastr.warning('User not selected', 'Warning');
        this.showProcessingIndicator = false;
       }
   
  
      } 




  getUserPermissionByUserName(){
    this.initializeUserPermissions();

    if(this.selectedUser){
      this.userService.getUserPermission(this.selectedUser).subscribe(
        (res)=> { 
          if(res.length > 0){
              this.userPermissionArray= res;
           
            }else{
              this.initializeUserPermissions();
            } 
           
        },
        (err) => {
          this.toastr.error('Failed to load data', 'Failure');
          if(err instanceof HttpErrorResponse){                 
            if(err.status == 401){
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        },

      )
    }
       

  }
  
  selectAllcheckedChange(){ 
    this.initializeUserPermissions();
    if(this.selectAll){
      this.checkedAllPermissions();
    }
  }

  clearPanel(){
    this.selectedUser = null;
    this.selectAll = false;
    this.initializeUserPermissions();
  }

 

  deleteUserPermissionBtnClick(): void {

    if(this.selectedUser){

        this.dialogService.openConfirmDialog('Are you sure you want to delete all  permission granted to this user')
        .afterClosed().subscribe(res => {
          if (res) {
            this.userService.delete(this.selectedUser)
              .subscribe(
                (res) => {
                  this.toastr.success('Deleted successfully', 'Success');
                  this.clearPanel(); 
                },
                (err) => {
                  this.toastr.error('Failed to delete permission', 'Failure');
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                },
              )
          } 
        })
     
     }else{
      this.toastr.warning('User not selected', 'Warning');
     }

  }


} //end class
